/* Astral Society – límite de importe por pedido */
(function () {
  var cfg = window.AstralOrderLimit;
  if (!cfg || window.__astralOrderLimit) return;
  window.__astralOrderLimit = true;
  var total = null;
  var TRIG = 'button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, #checkout, a[href*="/checkout"]';

  function fmt(c) {
    var n = (c / 100).toFixed(2).split('.');
    var s = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
    return (cfg.moneyFormat || '{{amount_with_comma_separator}} €').replace(/\{\{\s*[\w_]+\s*\}\}/, s);
  }
  function over() { return total !== null && total > cfg.limit; }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  function ensureNotices() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      if (prev && prev.hasAttribute('data-order-limit-notice')) return;
      var d = document.createElement('div');
      d.className = 'ol-notice'; d.setAttribute('data-order-limit-notice', ''); d.setAttribute('role', 'alert'); d.hidden = true;
      d.innerHTML = '<strong></strong><span class="ol-msg"></span><span class="ol-detail" data-order-limit-detail></span>';
      d.querySelector('strong').textContent = cfg.title;
      d.querySelector('.ol-msg').textContent = cfg.message;
      ctas.parentNode.insertBefore(d, ctas);
    });
  }

  function apply() {
    ensureNotices();
    var o = over();
    document.querySelectorAll('[data-order-limit-notice]').forEach(function (n) {
      if (n.hidden === o) n.hidden = !o;
      setText(n.querySelector('[data-order-limit-detail]'), o ? 'Votre panier : ' + fmt(total) + ' — retirez au moins ' + fmt(total - cfg.limit) + ' pour continuer.' : '');
    });
    document.querySelectorAll(TRIG).forEach(function (b) {
      if (o) {
        if (!b.classList.contains('ol-blocked')) { b.classList.add('ol-blocked'); b.setAttribute('aria-disabled', 'true'); }
        if (b.tagName === 'BUTTON' && !b.disabled) b.disabled = true;
      } else if (b.classList.contains('ol-blocked')) {
        b.classList.remove('ol-blocked'); b.removeAttribute('aria-disabled');
        if (b.tagName === 'BUTTON') b.disabled = !(total > 0);
      }
    });
    document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (el) {
      var want = o ? 'none' : '';
      if (el.style.display !== want) el.style.display = want;
    });
  }

  function toast() {
    var t = document.querySelector('.ol-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ol-notice ol-toast'; t.setAttribute('role', 'alert');
      t.innerHTML = '<strong></strong><span class="ol-msg"></span>';
      document.body.appendChild(t);
    }
    t.querySelector('strong').textContent = cfg.title;
    t.querySelector('.ol-msg').textContent = cfg.message;
    t.hidden = false;
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function shake() {
    document.querySelectorAll('[data-order-limit-notice]').forEach(function (n) {
      if (n.hidden) return;
      n.classList.remove('ol-flash'); void n.offsetWidth; n.classList.add('ol-flash');
    });
  }
  function block(e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); shake(); toast(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(TRIG);
    if (b && over()) block(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (over() && ((s && s.name === 'checkout') || String(e.target.action || '').indexOf('/checkout') > -1)) block(e);
  }, true);

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; apply(); })
      .catch(function () {});
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 150); }, function () {});
    return p;
  };

  var timer = null;
  var mo = new MutationObserver(function () {
    if (total === null) return;
    clearTimeout(timer); timer = setTimeout(apply, 60);
  });

  function init() { refresh(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.AstralOrderLimit.refresh = refresh;
})();
